import axios from 'axios';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_FRONT_BROWSE_RECORD}`;

export const getBrowseRecord = (data) => axios.get(API_PATH, data());
